import { mapValues } from 'lodash/fp';

import prepareRoute from './prepareRoute';
import routes from './routes';

export default mapValues(prepareRoute, routes);
